import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsOurStory } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";

export default function OurStoryView() {
  const {id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return
    };
    const fetchData = async () => {
      try {
        const result = await getAboutUsOurStory(id);
        const storyData = result.data.data;
        setData(storyData)
      } catch (error) {
        console.error(error);
      }finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const columns = ["Member", "Image", "Position"];
  const rows = [];
  if(Array.isArray(data) && data.length > 0) {
    const item = data[0];
    rows.push([item.name1, item.image1 ? <img src={item.image1} alt={item.name1} height="150px" /> : "-", item.position1]);
    rows.push([item.name2, item.image2 ? <img src={item.image2} alt={item.name2} height="150px" /> : "-", item.position2]);
  }
 
  return (<>
  {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Our Story Section</HomeTitle>
      <CustomTable
        columns={columns}
        rows={rows}
        isLoading={isLoading}
      />
      {/* Button Section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/ourstory/edit/${id}`}
        >
          <Button>{Number(id) ? 'Edit' : 'Add'} Our Story Section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
  </>
  );
}

const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
    @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
